import React, {useState, useEffect} from "react";
import styles from './page.module.scss'
import { getStore } from "../../../utils/functions"
import axios from "axios"
import { ArrowPrevIcon } from "../../../components/icons/arrow-prev"
import { ArrowNextIcon } from "../../../components/icons/arrow-next"
import { TrashIcon } from '../../../components/icons/trash';
import { CloseIcon } from "../../../components/icons/close"
import { Button } from "../../../components/ui/panel-button"
import { Input } from "../../../components/ui/panel-input"
import { Text } from "../../../components/ui/text"
import { Heading } from "../../../components/ui/heading"
import { Img } from "../../../components/ui/img"
import { SelectBox} from "../../../components/ui/selectbox";
import { ReactTable } from "../../../components/layout/react-table";
import { createColumnHelper } from "@tanstack/react-table";

const dropDownOptions = [
  { label: "Option1", value: "option1" },
  { label: "Option2", value: "option2" },
  { label: "Option3", value: "option3" },
];

export default function UsersPage() {
  const auth = getStore("auth")
  const [searchBarValue, setSearchBarValue] = useState("");
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [pageButtonRange, setPageButtonRange] = useState([1, 3]);

  const totalPages = Math.ceil(tableData.length / entriesPerPage);
  const startIndex = (currentPage - 1) * entriesPerPage;
  const endIndex = startIndex + entriesPerPage;
  const currentPageData = tableData.slice(startIndex, endIndex);
  const [rowNumbers, setRowNumbers] = useState([]);

  function formatDate(isoString) {
    if(!isoString)
      return '';
    
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-indexed in JS
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
  
    return `${year}/${month}/${day} @ ${hours}:${minutes}:${seconds}`;
  }
  

  useEffect(() => {
    axios.get('/api/panel-details', {
      headers: { Authorization: `Token ${auth.token}` }
    })
    .then(response => {
      // Filter the data based on the search bar value
      const filteredData = response.data.filter(row => 
        Object.values(row).some(val => 
          String(val).toLowerCase().includes(searchBarValue.toLowerCase())
        )
      );
  
      // Add a new field 'rowNumber' to each object in the data array
      const dataWithRowNumbers = filteredData.map((row, index) => ({
        ...row,
        rowNumber: index + 1
      }));
  
      setTableData(dataWithRowNumbers);
    })
    .catch(error => {
      console.error('There was an error!', error);
    });
  }, [searchBarValue]);
  console.log(rowNumbers)
  const tableColumns = React.useMemo(() => {
    const tableColumnHelper = createColumnHelper();
    return [
      tableColumnHelper.accessor("rowNumber", {
        Cell: ({ value }) => (
          <div>
            <Text size="lg" as="p">
              {value}
            </Text>
          </div>
        ),
        header: (info) => (
          <Text size="lg" as="p" className="py-[18px] sm:pl-5 !text-white-A700">
            No
          </Text>
        ),
        meta: { width: "83px" },
      }),
      tableColumnHelper.accessor("full_name", {
        cell: (info) => (
          <Text as="p" className={styles.tablerows}>
            {info?.getValue?.()}
          </Text>
        ),
        header: (info) => (
          <Text size="lg" as="p" className="py-[18px] !text-white-A700">
            Name
          </Text>
        ),
        meta: { width: "138px" },
      }),
      tableColumnHelper.accessor("username", {
        cell: (info) => (
          <Text as="p" className={styles.tablerows}>
            {info?.getValue?.()}
          </Text>
        ),
        header: (info) => (
          <Text size="lg" as="p" className="py-[18px] !text-white-A700">
            Username
          </Text>
        ),
        meta: { width: "180px" },
      }),
      tableColumnHelper.accessor("total_bins", {
        cell: (info) => (
          <Text as="p" className={styles.tablerows}>
            {info?.getValue?.()}
          </Text>
        ),
        header: (info) => (
          <Text size="lg" as="p" className="py-[18px] !text-white-A700">
            Total Bins
          </Text>
        ),
        meta: { width: "176px" },
      }),
      tableColumnHelper.accessor("filled_bins", {
        cell: (info) => (
          <Text as="p" className={styles.tablerows}>
            {info?.getValue?.()}
          </Text>
        ),
        header: (info) => (
          <Text size="lg" as="p" className="py-[18px] !text-white-A700">
            Filled Bins
          </Text>
        ),
        meta: { width: "179px" },
      }),
      tableColumnHelper.accessor("unfilled_bins", {
        cell: (info) => (
          <Text as="p" className={styles.tablerows}>
            {info?.getValue?.()}
          </Text>
        ),
        header: (info) => (
          <Text size="lg" as="p" className="py-[18px] !text-white-A700">
            UnFilled Bins
          </Text>
        ),
        meta: { width: "191px" },
      }),
      tableColumnHelper.accessor("last_access", {
        cell: (info) => (
          <Text as="p" className={styles.tablerows}>
            {formatDate(info?.getValue?.())}
          </Text>
        ),
        header: (info) => (
          <Text size="lg" as="p" className="py-[18px] !text-white-A700">
            Last Access
          </Text>
        ),
        meta: { width: "293px" },
      }),
      tableColumnHelper.accessor("action", {
        cell: (info) => (
          <div className="flex justify-center">
            <TrashIcon className="h-[24px] w-[24px]" />
          </div>
        ),
        header: (info) => (
          <Text size="lg" as="p" className="pr-6 py-[18px] !text-white-A700">
            Action
          </Text>
        ),
        meta: { width: "86px" },
      }),
    ];
  }, []);

  return (
    <>
      <div className="w-full pb-[21px] sm:pb-5 bg-gray-100_01">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col w-full gap-7 mx-auto md:p-5 max-w-[1376px]">
            <div className="flex sm:flex-col justify-between items-center gap-5">
              <Heading size="xs" as="h1">
                Details
              </Heading>
              <div className="flex sm:flex-col justify-center w-[26%] sm:w-full gap-4">
                <Input
                  name="search"
                  placeholder={`Search`}
                  value={searchBarValue}
                  onChange={(e) => setSearchBarValue(e)}
                  prefix={
                    <Img
                      src="/media/images/panel/img_iconly_light_search.svg"
                      alt="Iconly/Light/Search"
                      className="cursor-pointer"
                    />
                  }
                  suffix={
                    searchBarValue?.length > 0 ? (
                      <CloseIcon onClick={() => setSearchBarValue("")} fillColor="#000000ff" />
                    ) : null
                  }
                  className="flex items-center justify-center h-[48px] pl-3 pr-[35px] gap-3 sm:pr-5 text-black-900 text-sm border-gray-300_01 border border-solid bg-white-A700 flex-1 rounded-md"
                />
              </div>
            </div>
            <ReactTable
              size="xs"
              variant="simple"
              bodyProps={{ className: "" }}
              headerProps={{ className: "border-green-400 border-t border-b border-solid bg-green-400 md:flex-wrap" }}
              rowDataProps={{ className: "border-black-900_19 border-b border-solid bg-white-A700 md:flex-col" }}
              className="w-[1376px] border-green-400 border border-solid"
              columns={tableColumns}
              data={currentPageData}
            />
            <div className="flex sm:flex-col justify-between items-center gap-5">
              <Text as="p" className="self-end opacity-0.75">
                Showing {currentPage * entriesPerPage - entriesPerPage + 1} - {Math.min(currentPage * entriesPerPage, tableData.length)} of {tableData.length} entries
              </Text>
              <div className="flex justify-between w-[17%] sm:w-full gap-5">
                <Button className="flex items-center justify-center h-[44px] w-[44px] border-blue_gray-100 border border-solid bg-white-A700 rounded-[3px]"
                  onClick={() => {
                    const newPage = Math.max(1, currentPage - 1);
                    setCurrentPage(newPage);
                    if (newPage < pageButtonRange[0]) {
                      setPageButtonRange([Math.max(1, pageButtonRange[0] - 1), Math.max(3, pageButtonRange[1] - 1)]);
                    }
                  }}
                >
                  <ArrowPrevIcon/>
                </Button>
                <div className={styles.pagination}>
                  {Array.from({ length: Math.min(totalPages - pageButtonRange[0] + 1, 3) }, (_, i) => pageButtonRange[0] + i)
                    .filter(pageNumber => pageNumber <= totalPages)
                    .map(pageNumber => (
                      <Button
                        key={pageNumber}
                        className={`flex items-center justify-center h-[44px] px-4 text-center text-base min-w-[44px] rounded-[3px] ${
                          pageNumber === currentPage ? 'text-white-A700 bg-green-400' : 'text-black-900_9e border-blue_gray-100 border border-solid bg-white-A700'
                        }`}
                        onClick={() => setCurrentPage(pageNumber)}
                      >
                        {pageNumber}
                      </Button>
                    ))
                  }
                </div>
                <Button className="flex items-center justify-center h-[44px] w-[44px] border-blue_gray-100 border border-solid bg-white-A700 rounded-[3px]"
                  onClick={() => {
                    const newPage = Math.min(totalPages, currentPage + 1);
                    setCurrentPage(newPage);
                    if (newPage > pageButtonRange[1]) {
                      setPageButtonRange([Math.min(totalPages - 2, pageButtonRange[0] + 1), Math.min(totalPages, pageButtonRange[1] + 1)]);
                    }
                  }}
                >
                  <ArrowNextIcon/>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
